import { MdlDialogReference } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component, Inject, InjectionToken } from '@angular/core';
export const DELETE_DIALOG_TOKEN = new InjectionToken('DeleteDialog');

@Component({
    selector: 'delete-modal',
    template: require('./delete-modal.component.html'),
    styles: [require('./delete-modal.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class DeleteModalComponent {

    public data: DeleteModalData;

    constructor(
        private dialog: MdlDialogReference,
        @Inject(DELETE_DIALOG_TOKEN) private readonly dialogData: DeleteModalData
    ) {
        this.data = dialogData;
    }

    public close() {
        const result = {
            action: 'Close',
            code: 0,
            isDeleted: false
        } as DeleteModalResult;

        this.dialog.hide(result);
    }

    public delete() {
        const result = {
            action: 'Delete',
            code: 1,
            isDeleted: true
        } as DeleteModalResult;

        this.dialog.hide(result);
    }
}

export interface DeleteModalData {
    title: string;
    content: string;
    closeButtonText: string;
    deleteButtonText: string;
    reverseButtons?: boolean;
    displayClose?: boolean;
}

export interface DeleteModalResult {
    action: string;
    code: number;
    isDeleted: boolean;
}